import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams } from "react-router-dom";
import { toast } from 'react-toastify';

export const StageCover = ({id, cover, storeMutate})=>{
    const { school } = useParams();
    const auth = useSelector(state => state.auth );
    const [coverContent, setcoverContent] = useState("");
    const minContentLength = useMemo(()=>{
        if( auth.grade>=5) return 90;
        if(auth.grade>=3) return 70;
        return 50;
    },[auth.grade]);
    
    const onStoreCovercomment = ()=>{
        if(storeMutate.isPending)return;
        if(auth.grade===1 || auth.grade===2){
            if(coverContent.length<50){
                toast.error('50자 이상 적어주세요.')
                return;
            }
        }else if(auth.grade===3 || auth.grade===4){
            if(coverContent.length<70){
                toast.error('70자 이상 적어주세요.')
                return;
            }
        }else if(auth.grade===5 || auth.grade===6 || auth.grade===7){
            if(coverContent.length<90){
                toast.error('90자 이상 적어주세요.')
                return;
            }

        }else{
            alert('1~7학년만 참여 가능합니다.');
            return;
        }
        storeMutate.mutate( {meeting_id:id, type:'cover', content:coverContent} );
    };

    return (
        <div className="StageCover">
            <div className="container">
                <div data-aos="fade-right"
                data-aos-duration="1000" className="cover">
                    <img src={(null!==cover && cover.startsWith('http://') )?`${cover}`:cover}  alt="큰 표지" />
                </div>
                <div className="text_box">
                { !auth.authenticated && 
                    <>
                        <textarea placeholder="표지를 보고, 어떤 이야기일지 &#13;&#10; 상상해서 써보아요. &#13;&#10; 로그인후 이용해주세요." disabled></textarea>
                        <Link className="btn _blue" to={`/${school}/signin`}>로그인</Link>
                    </>
                }

                { auth.authenticated &&
                    <>
                        <textarea placeholder={`표지를 보고, 어떤 이야기일지 상상해서 써보아요. ${(auth.grade===null?0:auth.grade)}학년은 ${minContentLength}자 이상 써야 저장됩니다. `} disabled={!auth.authenticated} value={coverContent} onChange={(e)=>setcoverContent(e.target.value)}> </textarea>
                        <button className="btn _blue" onClick={onStoreCovercomment}>상상 끝!</button>
                    </>
                }
                </div>
                
                
            </div>
        </div>
    )

};